import { useEffect, useState } from "react";
import { String2StringObj } from "@src/utils/utils";
import { useGetAnalyticsForCategoryQuery } from "@app/store/analyticsApi";
import { AnalyticsFiltersParams } from "./types";

export const useAnalyticsFilters = ({
    brandValue,
    modelValue,
    yearFromValue,
    generationValue,
    bodyValue,
    transmissionValue,
    engineTypeValue,
    driveValue,
    engineVolumeFromValue
}: AnalyticsFiltersParams) => {
    const [analyticsFilters, setAnalyticsFilters] = useState<String2StringObj>({});

    useEffect(() => {
        let newFilters: String2StringObj = {};

        const values = [
            brandValue,
            modelValue,
            yearFromValue,
            generationValue,
            bodyValue,
            transmissionValue,
            engineTypeValue,
            driveValue,
            engineVolumeFromValue
        ];

        if (values.some((val) => !val)) {
            setAnalyticsFilters({});
            return;
        }

        if (brandValue) {
            newFilters.mark = brandValue?.name;
        }

        if (modelValue) {
            newFilters.model = modelValue?.name;
        }

        if (yearFromValue) {
            newFilters.year = yearFromValue.toString();
        }

        if (generationValue && generationValue.generation) {
            newFilters.generation = generationValue.generation.toString();
        }

        if (engineVolumeFromValue) {
            newFilters.displacement = engineVolumeFromValue.toString();
        }

        if (bodyValue) {
            newFilters.prep_body_type = bodyValue;
        }

        if (engineTypeValue) {
            newFilters.prep_engine_type = engineTypeValue;
        }

        if (driveValue) {
            newFilters.prep_drive_type = driveValue;
        }

        if (transmissionValue) {
            newFilters.prep_transmission = transmissionValue;
        }

        setAnalyticsFilters(newFilters);
    }, [
        brandValue,
        modelValue,
        yearFromValue,
        generationValue,
        bodyValue,
        transmissionValue,
        engineTypeValue,
        driveValue,
        engineVolumeFromValue
    ]);

    const { data: analyticsData } = useGetAnalyticsForCategoryQuery(analyticsFilters, {});

    return { analyticsData };
};